define('components/radio-channel/radio-channel',[
    //'apps/debug-radio/main'
], function () {
    "use strict";

    return {
        "create": function (channelName, eventHash) {
            var channel = Backbone.Radio.channel(channelName);
            this.generateEventNames(eventHash);
            channel.Event = eventHash;
            return channel;
        },

        "generateEventNames": function (eventHash, eventPrefix) {
            eventPrefix = eventPrefix || '';

            _.each(eventHash, function (value, key) {
                var formattedKey = key.replace(/_/g, '-') // e.g. NEXT_SLIDE => next-slide
                                      .replace(/([a-z])([A-Z])/g, '$1-$2') // e.g. ResourceLoader => resource-loader
                                      .toLowerCase();

                if (value === null) {
                    eventHash[key] = eventPrefix + formattedKey;
                } else {
                    this.generateEventNames(value, eventPrefix + formattedKey + ':');
                }
            }, this);
        }
    };
});

